import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ModalContainer } from '../../common';

import styles from './css/ReimbursementMethodSection.module.css';

const VerifyOtpReimbursementModal = ({
  show = false,
  onCloseModalOtpConfirmation = () => {},
  onVerifyModalOtp = () => {},
  useSmsValidation = false,
  phoneNumber = '',
  hideEmail = '',
}) => {
  const { t } = useTranslation('myAccount');

  return (
    <ModalContainer
      cancelable={false}
      handleOutClick={onCloseModalOtpConfirmation}
      show={show}
    >
      <div className={styles.modalVerifyContainer}>
        <h2>{t('modalVeryOtp.title')}</h2>

        <p>{t('modalVeryOtp.description')}</p>

        <p>
          <Trans
            components={{ b: <strong /> }}
            i18nKey="modalVeryOtp.otpDescription"
            ns="myAccount"
            values={{
              ending: useSmsValidation ? phoneNumber?.slice(-4) : hideEmail,
              verificationType: useSmsValidation
                ? t('modalVeryOtp.emailVerification')
                : t('modalVeryOtp.phoneVerification'),
            }}
          />
        </p>

        <div className={styles.verifyButtonsContainer}>
          <button
            className={styles.cancelButton}
            onClick={onCloseModalOtpConfirmation}
            type="button"
          >
            <span>
              {t('modalVeryOtp.cancelButton')}
            </span>
          </button>

          <button
            className={styles.verifyButton}
            onClick={onVerifyModalOtp}
            type="button"
          >
            <span>
              {t('modalVeryOtp.verifyButton')}
            </span>
          </button>
        </div>
      </div>
    </ModalContainer>
  );
};

export { VerifyOtpReimbursementModal };
